let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aYK9M")).then(() => parcelRequire('3nImY'));